import React from 'react'
import { Box, Typography } from '@mui/material'
import Detail from './Detail'
import { useGetEndUserAppleLuckyDrawById } from '../../../../../api/promotions/end-user/end-user-apple-lucky-draw'
import { useParams } from 'react-router-dom'
import ResendButton from './ResendButton'
import { pending } from '../../../../../constant/status'
import RejectButton from './RejectButton'
import ApproveButton from './ApproveButton'

const AppleLuckyDrawDetail = () => {
  const { id } = useParams()
  const { data, isLoading } = useGetEndUserAppleLuckyDrawById(id)

  if (!data || isLoading) {
    return null
  }

  return (
    <Box
      mb={8}
      textAlign='center'
      boxShadow={1}
      style={{ color: '#464646', background: 'whitesmoke' }}
    >
      <Box p={4} pt={6}>
        {/* Business Name */}
        <Typography variant='h1' fontWeight={900} fontSize={36}>
          {data.name}
        </Typography>
      </Box>
      {/* Detail */}
      <Detail data={data}></Detail>

      {/* Actions */}
      <Box pb={6}>
        {data.status === pending && (
          <Box display={'flex'} justifyContent={'center'} gap={6}>
            <RejectButton id={data._id}></RejectButton>
            <ApproveButton id={data._id}></ApproveButton>
          </Box>
        )}

        {data.status !== pending && <ResendButton id={data._id}></ResendButton>}
      </Box>
    </Box>
  )
}

export default AppleLuckyDrawDetail
